import React from 'react';
import { connect } from 'react-redux';
import { Table, Button } from 'react-bootstrap';
import Draggable from 'react-draggable';
import _ from 'lodash';
import moment from 'moment';

import '../../../util/moment-duration';
import { formatWorkDuration } from '../../../util/dates';
import { saveConfig, updateBlockersChart } from '../../../components/Filter/FilterActions';

export class BlockersStats extends React.Component {
  constructor(props) {
    super(props);

    this.handleClose = this.handleClose.bind(this);
  }

  handleClose() {
    this.props.close(this.props.chart);
    this.props.saveConfig();
  }

  render() {
    const { markBlocked, chart, data, timePrecision, id, excludeWeekendOpts, useWorkingHoursInCycleTimeDays } = this.props;
    const isAging = chart === 'cta';

    if (!data || !data.length) {
      return <div></div>;
    }

    let rows = data.map((item) => {
      return (
        <tr key={item.list}>
          <td>
            <div className="label_box" style={{ background: item.color }}></div>
            {item.list}
          </td>
          <td>{item.total > 0 ? item.total : '---'}</td>
          {isAging && <td>{item.total > 0 ? item.currentlyBlocked : '---'}</td>}
          {isAging && <td>{item.total > 0 ? item.wasBlocked : '---'}</td>}
          <td>
            {item.total > 0
              ? formatWorkDuration(item.accumulatedMinutes, excludeWeekendOpts, timePrecision || 'd[d] h[h] m[m]', useWorkingHoursInCycleTimeDays)
              : '---'}
          </td>
          <td>{item.total > 0
              ? formatWorkDuration(item.average, excludeWeekendOpts, timePrecision || 'd[d] h[h] m[m]', useWorkingHoursInCycleTimeDays)
              : '---'}
          </td>
        </tr>
      );
    });

    return (
      <Draggable defaultPosition={{ x: 95, y: isAging ? 112 : 85 }} axis="both" bounds="parent">
        <div id={id} className="box_white_shadow table_metrics">
          <div className="box_white_title">
            <h3>Blockers</h3>
            
            <div className='right-actions'>
              <Button className="btn-action" onClick={this.handleClose}>&times;</Button>
            </div>
          </div>
          <Table>
            <thead>
              <tr>
                <th>&nbsp;</th>
                <th>
                  Total
                </th>
                {isAging && <th>
                  Currently <br />
                  blocked
                </th>}
                {isAging && <th>
                  Blocked <br />
                  in the past
                </th>}
                <th>
                  Accumulated <br />
                  time
                </th>
                <th>
                  Average
                </th>
              </tr>
            </thead>
            <tbody>{rows}</tbody>
          </Table>
        </div>
      </Draggable>
    );
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    close: (chart) => dispatch(updateBlockersChart(false, chart)),
    saveConfig: () => dispatch(saveConfig()),
  };
};

const mapStateToProps = (state) => {
  const chart = state.filters.chart;
  return {
    chart: state.filters.chart,
    markBlocked: state.filters[chart].markBlocked,
    timePrecision: state.filters.timePrecision,
    excludeWeekendOpts: {
      type: state.filters.excludeWeekends,
      workStart: state.filters.workStart,
      workEnd: state.filters.workEnd,
      holidays: state.filters.holidays
    },
    useWorkingHoursInCycleTimeDays: state.auth.user.config && state.auth.user.config.useWorkingHoursInCycleTimeDays
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(BlockersStats);
